import { User } from "../types";

const PROFILE_URL = process.env.REACT_APP_TREEZ_PROFILE_URL;

export const getProfile = async (accessToken: string): Promise<User> => {
    const response = await fetch(PROFILE_URL, {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) {
        throw new Error("Failed to fetch profile");
    }
    return response.json();
};
